import { render, staticRenderFns } from "./infoRequest.vue?vue&type=template&id=d50f1dd0"
import script from "./infoRequest.vue?vue&type=script&lang=js"
export * from "./infoRequest.vue?vue&type=script&lang=js"
import style0 from "./infoRequest.vue?vue&type=style&index=0&id=d50f1dd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports